import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

import { API_PARAMS } from '../../config/consts'

export interface GetFloorListResponse {
  // description: string | null
  // floorDetailHash: string
  floorID: number
  // floorPlanImgUrl: string | null
  // imageID: number
  // level: string
  name: string
  // numOfBeacons: number
  // orderNo: number
  siteID: number
}

const useGetFloorList = (siteId: string | null) => {
  const accessToken = Cookies.get('LoginToken')

  const fetcher = (url: string): Promise<GetFloorListResponse[]> => axios.get(url).then((res) => res.data.floors)
  const { data, isLoading } = useSWR(
    () =>
      siteId !== '' && siteId !== null && siteId !== API_PARAMS.SELECT_ALL && accessToken
        ? `${process.env.REACT_APP_API_DOMAIN}/1/Console/GetFloorList?accessToken=${accessToken}&siteID=${siteId}`
        : null,
    fetcher,
    { revalidateOnFocus: false, revalidateOnReconnect: false, shouldRetryOnError: false },
  )

  return { floors: data, floorsLoading: isLoading }
}

export default useGetFloorList
